// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvancedFiltersController from "./advanced_filters_controller"
application.register("advanced-filters", AdvancedFiltersController)

import BomRepeaterController from "./bom_repeater_controller"
application.register("bom-repeater", BomRepeaterController)

import DateRangeFilterController from "./date_range_filter_controller"
application.register("date-range-filter", DateRangeFilterController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import EditableFormController from "./editable_form_controller"
application.register("editable-form", EditableFormController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistoryFrameController from "./history_frame_controller"
application.register("history-frame", HistoryFrameController)

import InputUnitController from "./input_unit_controller"
application.register("input-unit", InputUnitController)

import LaborRepeaterController from "./labor_repeater_controller"
application.register("labor-repeater", LaborRepeaterController)

import LaborValidationController from "./labor_validation_controller"
application.register("labor-validation", LaborValidationController)

import MachineryRepeaterController from "./machinery_repeater_controller"
application.register("machinery-repeater", MachineryRepeaterController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PriceRangeFilterController from "./price_range_filter_controller"
application.register("price-range-filter", PriceRangeFilterController)

import RegistrationValidationController from "./registration_validation_controller"
application.register("registration-validation", RegistrationValidationController)

import ShipmentPricingController from "./shipment_pricing_controller"
application.register("shipment-pricing", ShipmentPricingController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)
